import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from "react-on-screen";

const Data = [
    {
        countNum : 2555,
        countTitle: 'Happy Clients',
        
    },
    {
        countNum : 1027,
        countTitle: 'Projects Completed',
    },
    {
        countNum : 69,
        countTitle:  'Skilled Professionals',
    },
    {
        countNum : 10,
        countTitle:  'Global Projects',
    },
    {
        img: "/images/about/years3.png",   // your right-side image here
    },
];

const CounterUpFour = ({textALign, counterStyle, column}) => {
    return (
        <div className="row" style={{ marginBottom: '0' }}>
            {Data.map((data, index) => {
                // Image items take full width, counters take 2 per row
                const colClass = data.img ? 'col-lg-12 col-md-12 col-sm-12 col-12' : (column || 'col-lg-6 col-md-6 col-sm-6 col-12');
                return (
                <div className={colClass} key={index} style={{ marginBottom: '20px' }}>
                    <div className={`count-box ${counterStyle} ${textALign}`}>

                            {/* If number exists → show CountUp */}
                            {data.countNum && (
                                <TrackVisibility once>
                                    {({ isVisible }) =>
                                        isVisible &&
                                        <div className="count-number">
                                            {isVisible ? <CountUp end={data.countNum} /> : 0}
                                        </div>
                                    }
                                </TrackVisibility>
                            )}

                            {/* If title exists → show title */}
                            {data.countTitle && (
                                <h5 className="counter-title">{data.countTitle}</h5>
                            )}

                            {/* If image exists → show image */}
                            {data.img && (
                                <img
                                    src={data.img}
                                    alt="Global industrial solutions"
                                    style={{
                                        width: "200px",
                                        height: "200px",
                                        objectFit: "contain",
                                        // paddingBottom: "300px",
                                        // marginTop: "0",
                                    }}
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default CounterUpFour;